import React from 'react';
import Square from "../Square/Square";
import TeamSquare from "../TeamSquare/TeamSquare";
import SearchPlayers from "../SearchPlayers/SearchPlayers";
import logo from '../../img/logo.png';
import './Board.css';

const Board = ({ squares, onClick, turn, winningSquares, clubSquares, handlePlayerSelect, player, mode, league, isStealMode, stealCap, stealFlashSquare, isFour12Mode, lockedSquare, revealedItems }) => {

    // Modo Robo: CUALQUIER casilla ocupada dispara el click (la página decide qué feedback dar:
    // robar, reforzar la propia, avisar que llegó al tope, etc.) — así el jugador siempre
    // recibe un mensaje en vez de que el click no haga nada. Modo Clásico: solo las vacías.
    // Modo 412: solo vacías, y si ya hay una casilla "elegida" este turno (lockedSquare), las
    // demás vacías tampoco son jugables — hay que resolver esa antes de tocar cualquier otra.
    const isSquarePlayable = (square, idx) => {
        if (square.value !== '') return isStealMode;
        if (isFour12Mode) return lockedSquare === null || lockedSquare === idx;
        return true;
    };

    // Solo para el estilo visual: distinguir "jugable ahora" (propia o del rival) de "bloqueada"
    // (nadie puede tocarla más), ya sea porque llegó al tope de jugadas o porque alguien la
    // blindó a propósito (blindaje: una vez por jugador por partida, la casilla que elija
    // queda intocable para siempre sin importar el tope).
    const isSquareLocked = square => (
        isStealMode && square.value !== '' &&
        (square.shielded === true || (stealCap !== 'unlimited' && (square.claims || 0) >= stealCap))
    );
    const isSquareStealable = square => (
        isStealMode && square.value !== '' && square.value !== turn && !isSquareLocked(square)
    );
    const isSquareReinforceable = square => (
        isStealMode && square.value !== '' && square.value === turn && !isSquareLocked(square)
    );

    const createSquares = values => (
        values.map(value => {
            const square = squares[value];
            if (!square) return null;
            return (
                <Square
                    winner={winningSquares.includes(value)}
                    turn={turn}
                    onClick={() => onClick(value)}
                    value={square.value}
                    key={`square_${value}`}
                    playerName={square.playerName}
                    playerImg={square.photoUrl || square.playerImg}
                    isPlayable={isSquarePlayable(square, value)}
                    isStealable={isSquareStealable(square)}
                    isReinforceable={isSquareReinforceable(square)}
                    isLocked={isSquareLocked(square)}
                    isShielded={square.shielded === true}
                    stealFlash={stealFlashSquare === value}
                    claims={square.claims}
                    isChosen={isFour12Mode && lockedSquare === value}
                />
            );
        })
    );

    const createTeamSquares = values => (
        values.map(value => (
            <TeamSquare
                team={clubSquares[value]}
                hidden={isFour12Mode && revealedItems && !revealedItems.has(value)}
                key={`teamSquare_${value}`}
            />
        ))
    );

    return (
        <div className="board">
            <div className="row">
                <img className="logo" src={logo} alt="logo" />
                {createTeamSquares([0, 1, 2])}
            </div>
            <div className="row">
                {createTeamSquares([3])}
                {createSquares([0, 1, 2])}
            </div>
            <div className="row">
                {createTeamSquares([4])}
                {createSquares([3, 4, 5])}
            </div>
            <div className="row">
                {createTeamSquares([5])}
                {createSquares([6, 7, 8])}
            </div>
            <div className="board-search">
                {mode === 'bot' && turn === 'O'
                    ? <div className="waiting-bot-turn">Waiting for Bot... ⚽</div>
                    : <SearchPlayers
                        onSelect={handlePlayerSelect}
                        turn={turn}
                        player={player}
                        league={league}
                        lockedHint={isFour12Mode && lockedSquare === null ? 'wait-square' : null}
                      />
                }
            </div>
        </div>
    );
};

export default Board;
